import formatNumber from 'helpers/formatNumber';
import getEntityKey from 'helpers/getEntityKey';

import existsIn from 'components/data-containers/PerformanceTrend/helpers/existsIn';
import getClosestDate from 'components/data-containers/PerformanceTrend/helpers/getClosestDate';

/** To identify and change the labels for complex contentTypes (ugc-views, ugc-creations, pgc-views, pgc-creations) this function is added */
const getLabels = (breakdown: string): string => breakdown.split('-').join(' ');

const getDataToggleDetails = (
  trends: any,
  period: any,
  colorScale: any
): any => {
  if (
    trends?.filter((trend: any) => trend === undefined).length > 0 ||
    !trends ||
    !period
  )
    return undefined;

  // Does the selected period exist in the data?
  const periodExists = existsIn(trends, period);
  const closestDate = getClosestDate(period, trends);

  return trends.map((trend: any) => {
    const { breakdown = undefined, data } = trend;
    const d = data.find((d: any) =>
      periodExists
        ? d.date.getTime() === Number(period)
        : d.date.getTime() === closestDate?.getTime()
    );
    const selector = getEntityKey(trend);

    return {
      label: getLabels(breakdown),
      value: formatNumber(d?.value, 'number', true),
      key: selector,
      dataColor: colorScale(trend),
      selector,
      rawValue: d?.value,
    };
  });
};

export default getDataToggleDetails;
